module.exports = __webpack_public_path__ + "img/CoursePreview.d869ee28.jpeg";